import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class quizzesView_template extends vnTemplate {

    public brandSingleFilter: filterDropdown_template;

    protected getTemplateHtml(): string {
        return `
            <div class="w-form w-form-large form-poll">
                <div class="form-header">
                    <input id="quiz-id" data-bind="value: id" type="hidden">
                    <button class="btn icon i-back" type="button" data-bind="event: { click: onClickCancel }">Go Back</button>
                    <h3 class="form-title icon i-poll">Quiz</h3>
                    <button class="btn icon i-edit" type="button" data-bind="event: { click: onClickEdit }">Edit Quiz</button>
                </div>

                <div class="w-form-body">
                    <div class="form-body full-width" style="border-bottom: 0">
                        <strong class="form-sub-title" style="margin-bottom: 0">Info</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt class="full-width"><span>Title</span></dt>
                                <dd class="full-width"><span data-bind="text: title"></span></dd>
                            </dl>
                        </div>
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt class="full-width"><span>Brands</span></dt>
                                <dd class="full-width"><span data-bind="text: attachedBrands"></span></dd>
                            </dl>
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt><span>Source Article</span></dt>
                                <dd><span data-bind="text: sourceArticleDisplay() || 'None'"></span></dd>
                                <dt><span>Date Created</span></dt>
                                <dd><span data-bind="text: dateCreated() || 'Not Selected'"></span></dd>
                                <dt><span>Date Updated</span></dt>
                                <dd><span data-bind="text: dateUpdated() || 'Not Selected'"></span></dd>
                            </dl>
                        </div>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body full-width" style="border-bottom: 0">
                        <strong class="form-sub-title" style="margin-bottom: 0">Stats</strong>
                    </div>
                </div>

                <div class="w-form-body w-justify quiz-view-stats-row">
                    <div class="w-right quiz-view-stats-filter">
                        ${this.brandSingleFilter.getHtmlBuild()}
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <dl class="double-list margin">
                                <dt><span>Number of Questions</span></dt>
                                <dd><span data-bind="text: numberOfQuestions"></span></dd>
                                <dt><span>Number of Respondents</span></dt>
                                <dd><span data-bind="text: selectedStats().numberOfRespondents"></span></dd>
                                <dt><span>Average Score</span></dt>
                                <dd><span data-bind="text: selectedStats().averageScore"></span></dd>
                            </dl>
                        </div>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body full-width" style="border-bottom: 0">
                        <strong class="form-sub-title" style="margin-bottom: 0">Questions</strong>
                    </div>
                </div>

                <div data-bind="foreach: questions">
                    <div class="w-form-body question-view-card">
                        <strong class="form-sub-title" style="margin-bottom: 0">
                            <dd><span data-bind="text: question"></span></dd>
                        </strong>
                        <div class="form-body">
                            <div class="form-group">
                                <dl class="double-list margin">
                                    <dt><span>Difficulty</span></dt>
                                    <dd><span data-bind="text: difficulty"></span></dd>
                                    <dt><span>Basis</span></dt>
                                    <dd><span data-bind="text: basis"></span></dd>
                                    <dt><span>Rationale</span></dt>
                                    <dd><span data-bind="text: rationale"></span></dd>
                                </dl>
                            </div>
                        </div>
                        <div class="form-body">
                            <div class="view choices">
                                <div data-bind="foreach: options">
                                    <div class="form-group row" data-bind="css: { 'quiz-option-row--correct': isCorrect }">
                                        <span class="form-label" type="text" data-bind="text: text"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected initPartial(): void {
        this.brandSingleFilter = new filterDropdown_template("brandSingleFilter", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "quizzesView-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            id: ko.observable(null),
            brandId: ko.observable(null),
            title: ko.observable(""),
            attachedBrands: ko.observable(""),
            idSourceArticle: ko.observable(null),
            idSourceArticleBrand: ko.observable(null),
            sourceArticle: ko.observable(null),
            sourceArticleDisplay: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            numberOfQuestions: ko.observable(0),
            questions: ko.observableArray([]),
            stats: ko.observable({network: {numberOfRespondents: 0, averageScore: 0}, brands: {}}),
            selectedStats: ko.observable({numberOfRespondents: 0, averageScore: 0}),
            brandReferences: ko.observableArray([]),
            onClickCancel: (data, event) => {
                self.onClickCancel(data);
            },
            onClickEdit: (data, event) => {
                self.onClickEdit(data);
            },
        };
    }

    public onClickEdit(data): void {
        this.caller.edit(this.getId(), this.getBrandId());
    }

    public onClickCancel(data): void {
        this.caller.cancel(this.getId(), this.getBrandId());
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public setBrandId(brandId): void {
        this.getTemplateViewModel().brandId(brandId);
    }

    public getBrandId() {
        return this.getTemplateViewModel().brandId();
    }

    public setTitle(title): void {
        this.getTemplateViewModel().title(title);
    }

    public setIdSourceArticle(idSourceArticle): void {
        this.getTemplateViewModel().idSourceArticle(idSourceArticle);
    }

    public setIdSourceArticleBrand(idSourceArticleBrand): void {
        this.getTemplateViewModel().idSourceArticleBrand(idSourceArticleBrand);
    }

    public setDateCreated(dateCreated): void {
        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setDateUpdated(dateUpdated): void {
        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setNumberOfQuestions(numberOfQuestions): void {
        this.getTemplateViewModel().numberOfQuestions(numberOfQuestions);
    }

    public setQuestions(questions): void {
        this.getTemplateViewModel().questions(questions);
    }

    public setStats(stats): void {
        let fallbackStats = {network: {numberOfRespondents: 0, averageScore: 0}, brands: {}};
        this.getTemplateViewModel().stats(stats || fallbackStats);
        this.setSelectedStats((stats || fallbackStats).network || fallbackStats.network);
    }

    public setBrandReferences(brandReferences): void {
        let lightReferences = [];
        for (const brandReference of (brandReferences || [])) {
            lightReferences.push({
                id: brandReference.id,
                name: brandReference.name,
                shortName: brandReference.shortName
            });
        }

        this.getTemplateViewModel().brandReferences(lightReferences);
        this.refreshSourceArticleDisplay();
    }

    public getBrandReferences() {
        return this.getTemplateViewModel().brandReferences();
    }

    public setBrandResults(stats, activeBrandIds): void {
        let references = this.getBrandReferences();
        let brandReferences = [{id: -1, name: "Network", shortName: "Network"}];
        let brandNames = [];

        for (let reference of references) {
            if (activeBrandIds.indexOf(Number(reference.id)) !== -1) {
                brandReferences.push(reference);
                brandNames.push(reference.shortName || reference.name);
            }
        }

        this.setAttachedBrands(brandNames.join(", "));
        this.brandSingleFilter.setOptions(brandReferences);
        this.brandSingleFilter.setSelectedOption(-1);
        this.setStats(stats);
    }

    public handleBrandChange(idElement): void {
        let selectedBrand = this.brandSingleFilter.getSelectedOption();
        let stats = this.getTemplateViewModel().stats();
        if (selectedBrand && selectedBrand.id > 0) {
            let brandStats = stats.brands || {};
            this.setSelectedStats(brandStats[selectedBrand.id] || {numberOfRespondents: 0, averageScore: 0});
            return;
        }

        this.setSelectedStats(stats.network || {numberOfRespondents: 0, averageScore: 0});
    }

    public setAttachedBrands(attachedBrands): void {
        this.getTemplateViewModel().attachedBrands(attachedBrands);
    }

    public setSelectedStats(stats): void {
        this.getTemplateViewModel().selectedStats(stats || {numberOfRespondents: 0, averageScore: 0});
    }

    public setQuiz(data): void {
        this.setId(data.id || null);
        this.setTitle(data.title || "");
        this.setIdSourceArticle(data.idSourceArticle || null);
        this.setIdSourceArticleBrand(data.idSourceArticleBrand || null);
        this.setSourceArticleDisplay(data.article || null);
        this.setDateCreated(data.dateCreated || "");
        this.setDateUpdated(data.dateUpdated || "");
        this.setNumberOfQuestions(data.numberOfQuestions || (data.quiz || []).length || 0);
        this.setQuestions(this.formatQuestions(data.quiz || []));
        this.setStats(data.stats || {network: {numberOfRespondents: 0, averageScore: 0}, brands: {}});
    }

    protected setSourceArticleDisplay(article): void {
        this.getTemplateViewModel().sourceArticle(article);
        this.refreshSourceArticleDisplay();
    }

    protected refreshSourceArticleDisplay(): void {
        const sourceArticle = this.getTemplateViewModel().sourceArticle();
        if (sourceArticle && sourceArticle.id) {
            this.getTemplateViewModel().sourceArticleDisplay(this.getSourceArticleDisplayTitle(sourceArticle));
            return;
        }

        const idSourceArticle = this.getTemplateViewModel().idSourceArticle();
        this.getTemplateViewModel().sourceArticleDisplay(idSourceArticle ? this.getSourceArticleDisplayTitle({
            id: idSourceArticle,
            title: "Article #" + idSourceArticle,
        }) : "");
    }

    protected getSourceArticleDisplayTitle(article): string {
        if (!article || !article.id) {
            return "";
        }

        const title = article.title || "";
        const id = article.id || "";
        const brandName = this.getSourceArticleBrandName(article);

        return `${title} (${id} - ${brandName})`;
    }

    protected getSourceArticleBrandName(article = null): string {
        if (article) {
            const articleBrandName = article.brandName || article.brandShortName || article.brand || article.shortName;
            if (articleBrandName) {
                return articleBrandName;
            }
        }

        const sourceArticleBrandId = this.getTemplateViewModel().idSourceArticleBrand();
        const brand = (this.getBrandReferences() || []).find((brandReference) => {
            return Number(brandReference.id) === Number(sourceArticleBrandId);
        });

        return brand ? (brand.name || brand.shortName || "") : "";
    }

    protected formatQuestions(questions): Array<any> {
        return (questions || []).map((question) => {
            let options = question.options || [];
            let answer = question.answer || "";
            let correctOptionIndex = typeof question.correctOptionIndex !== "undefined" ? question.correctOptionIndex : null;

            return {
                question: question.question || "",
                difficulty: question.difficulty || "",
                basis: question.basis || "",
                rationale: question.rationale || answer || "",
                options: options.map((option, index) => {
                    let text = option.text || option.option || option.choiceText || "";
                    return {
                        text: text,
                        isCorrect: option.isCorrect === true || option.isCorrect === "on" || correctOptionIndex === index || (!!answer && answer === text)
                    };
                })
            };
        });
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/quizzesView_template.ts